/**
 * Excel sheet name constants, prefixes, and detection patterns.
 */

/** Excel maximum sheet name length */
export const SHEET_NAME_MAX_LENGTH = 31;

/** Known sheet names (exact match) */
export const SHEET_NAMES = {
  DASHBOARD: "Dashboard",
  RAW_DATA: "Raw Data",
  INVENTORY_RAW_DATA: "Inventory Raw Data",
  ADVERTISING_RAW_DATA: "Advertising Raw Data",
} as const;

/** Sheet name prefixes for .startsWith() checks */
export const SHEET_PREFIXES = {
  /** Matches any Market Watch sheet (MW Raw Data, MW Recommendations, etc.) */
  MW: "MW ",
  /** Matches Market Watch raw data sheets specifically */
  MW_RAW_DATA: "MW Raw Data",
} as const;

/** Regex patterns for sheet name detection */
export const SHEET_PATTERNS = {
  SALES_RAW_DATA: /Sales Raw Data/i,
  SALES_DATA: /Sales Data/i,
  SALES_DATA_GLOBAL: /Sales Data/gm,
  INVENTORY_RAW_DATA: /Inventory Raw Data/i,
  ADVERTISING_RAW_DATA: /Advertising Raw Data/i,
  ADVERTISING_RAW_DATA_NUMBERED: /Advertising Raw Data(?:\s*\(\d+\))?/,
} as const;

/** Dashboard type identifiers used in .includes() checks */
export const SHEET_TYPE_KEYWORDS = {
  SALES: "Sales",
  INVENTORY: "Inventory",
  ADVERTISING: "Advertising",
  MARKETING: "Marketing",
  ADVERTISING_DASHBOARD: "Advertising Dashboard",
  DASHBOARD: "Dashboard",
  DATA: "Data",
} as const;
